module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[99]98.7ec05e4.woff2";